export default __webpack_public_path__ + "static/media/bar.e76d0d2d.svg";